const languageMetadata = require("../data/translations.json");

const supportedLanguages = Object.keys(languageMetadata);

// Must export using ES5 to import in gatsby-node.js
module.exports.languageMetadata = languageMetadata
module.exports.supportedLanguages = supportedLanguages